import { render, staticRenderFns } from "./Audiogram.vue?vue&type=template&id=87574d54&scoped=true"
import script from "./Audiogram.vue?vue&type=script&lang=js"
export * from "./Audiogram.vue?vue&type=script&lang=js"
import style0 from "./Audiogram.vue?vue&type=style&index=0&id=87574d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87574d54",
  null
  
)

export default component.exports